module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "viewbox1",
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("被保险人是否具有以下任何一种情况？")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, _vm._l((_vm.notifies), function(notify) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(notify)
      }
    })
  }))]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.fit === false
    },
    on: {
      "click": function () {
        _vm.fit = false
      }
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.fit === true
    },
    on: {
      "click": function () {
        _vm.fit = true
      }
    }
  }, [_vm._v("确认无以上情况")])]), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("下一步")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f1e94a4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notify.vue
// module id = 653
// module chunks = 1